exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".public__update-banner {\n  background-color: #f7f7f7;\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);\n  font-family: 'Proxima Nova', Helvetica, Arial, sans-serif;\n  font-size: 16px;\n  color: #b20033;\n  line-height: 24px;\n  padding: 12px 80px 16px;\n  text-align: center;\n}\n@media (max-width: 992px) {\n  .public__update-banner {\n    padding: 12px 40px 16px;\n  }\n}\n@media (max-width: 768px) {\n  .public__update-banner {\n    padding: 20px 20px 20px 20px;\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/components/PublicWebsite/UpdateBanner/UpdateBanner.styles.less
// module id = 4838
// module chunks = 41